import axiosInstance from '../../api/axiosInstance';

export const SectionsTreeSelectionAPI = {
    getProductionLinesAndSections: (company, factory) =>
        axiosInstance.get(
            `${company}/${factory}/productionLines/by-user-scopes`
        ),
};
